import React, { useState,useEffect } from 'react'
import './index.less'
import { Icon } from 'antd'
import {PopoverProps,AppPopover }from '../AppPopover'
import { default as  AppDialog,DialogProps }from '../AppDialog'

export interface AppLookupProps {
    value?: string
    text?: string
    placeholder?: string
    onChange?: (value?: string,text?:string) => void
    lookupMode?:number   // 0 打开一个dialog (默认)  1 在控件下方浮动选择
    lookupPopoverProps?:PopoverProps  // 模式为1时生效
    lookupDialogProps?:DialogProps     // 模式为0时候生效
    lookupRender? :(lookup?:AppLookup) => JSX.Element | string   // 打开的选择界面
}



export  class AppLookup extends React.Component<AppLookupProps>{
    state = {
        itemState:'default',
        value : this.props.value || '',
        text : this.props.text || ''
    }

    // componentDidMount(){
    // }
    
    onLookup = async () =>{
        if(this.props.lookupRender){
            if(this.props.lookupMode === 1){
                AppPopover.open(null,{...this.props.lookupPopoverProps},this.refDiv.current, this.props.lookupRender(this));
            }else{
                AppDialog.open(null,{...this.props.lookupDialogProps},this.props.lookupRender(this));
            }
        } 
    }

    refDiv = React.createRef<HTMLDivElement>();

    render () {
        let {itemState,text} = this.state
        return (
            <span className='app-input-main'>
                <div className='app-input-container' ref={this.refDiv} data-state = {itemState}>
                    <div className='app-input-middle'>
                        <input 
                            placeholder={this.props.placeholder || ''}
                            defaultValue={text}
                            onFocus={e => this.setState({itemState:'active'}) }
                            onBlur = {e => this.setState({itemState:'default'}) }
                            readOnly
                        />
                    </div>
                    <div className='app-lookup-right' onClick={this.onLookup}>
                        <span><Icon type="plus"/> </span>
                    </div>
                </div>
            </span>
        )
    }


}




// WEBPACK FOOTER //
// ./src/qcc/AppInput/AppLookup.tsx